import blog1 from '../assets/images/blog/01.jpg'
import blog2 from '../assets/images/blog/02.jpg'
import blog3 from '../assets/images/blog/03.jpg'
import blog4 from '../assets/images/blog/04.jpg'
import blog5 from '../assets/images/blog/05.jpg'
import blog6 from '../assets/images/blog/06.jpg'
import blog7 from '../assets/images/blog/07.jpg'
import blog8 from '../assets/images/blog/08.jpg'
import blog9 from '../assets/images/blog/09.jpg'
import blog10 from '../assets/images/blog/10.jpg'
import blog11 from '../assets/images/blog/11.jpg'
import blog12 from '../assets/images/blog/12.jpg'

import blog15 from '../assets/images/blog/15.jpg'
import blog16 from '../assets/images/blog/16.jpg'
import blog17 from '../assets/images/blog/17.jpg'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'
import client4 from '../assets/images/client/04.jpg'
import client5 from '../assets/images/client/05.jpg'
import client6 from '../assets/images/client/06.jpg'
import client7 from '../assets/images/client/07.jpg'
import client8 from '../assets/images/client/08.jpg'

import portfolio1 from '../assets/images/portfolio/01.jpg'
import portfolio2 from '../assets/images/portfolio/02.jpg'
import portfolio3 from '../assets/images/portfolio/03.jpg'
import portfolio4 from '../assets/images/portfolio/04.jpg'
import portfolio5 from '../assets/images/portfolio/13.jpg'
import portfolio6 from '../assets/images/portfolio/15.jpg'
import portfolio7 from '../assets/images/portfolio/16.jpg'
import portfolio8 from '../assets/images/portfolio/18.jpg'
import portfolio9 from '../assets/images/portfolio/09.jpg'
import portfolio10 from '../assets/images/portfolio/10.jpg'
import portfolio11 from '../assets/images/portfolio/11.jpg'
import portfolio12 from '../assets/images/portfolio/12.jpg'

export const blogData = [
    {
        id:1,
        image:blog1,
        tag:'Marketing',
        date:'13th Sep, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client1,
        clientName:'Lisa Marvel'
    },
    {
        id:2,
        image:blog2,
        tag:'Event',
        date:'29th Nov, 24',
        title:'Become more money-minded',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client2,
        clientName:'Joya Aafri'
    },
    {
        id:3,
        image:blog3,
        tag:'Software',
        date:'29th Dec, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client3,
        clientName:'Martin Sobhe'
    },
    {
        id:4,
        image:blog4,
        tag:'Marketing',
        date:'13th March, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client4,
        clientName:'Lisa Marvel'
    },
    {
        id:5,
        image:blog5,
        tag:'Event',
        date:'5th May, 24',
        title:'Become more money-minded.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client5,
        clientName:'Joya Aafri'
    },
    {
        id:6,
        image:blog6,
        tag:'Software',
        date:'19th June, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client6,
        clientName:'Martin Sobhe'
    },
    {
        id:7,
        image:blog7,
        tag:'Marketing',
        date:'20th June, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client7,
        clientName:'Lisa Marvel'
    },
    {
        id:8,
        image:blog8,
        tag:'Event',
        date:'31st Aug, 24',
        title:'Become more money-minded',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client8,
        clientName:'Joya Aafri'
    },
    {
        id:9,
        image:blog9,
        tag:'Software',
        date:'1st Sep, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client1,
        clientName:'Martin Sobhe'
    },
    {
        id:10,
        image:blog10,
        tag:'Marketing',
        date:'13th March, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client2,
        clientName:'Lisa Marvel'
    },
    {
        id:11,
        image:blog11,
        tag:'Event',
        date:'5th May, 24',
        title:'Become more money-minded.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client3,
        clientName:'Joya Aafri'
    },
    {
        id:12,
        image:blog12,
        tag:'Software',
        date:'19th June, 24',
        title:'Quick guide on business with friends.',
        desc:'There is now an abundance of readable dummy texts. These are usually used when a text is required purely to fill a space.',
        clientImg:client4,
        clientName:'Martin Sobhe'
    },
]

export const catagories = [
    {
        title:'Finance',
        value:'13'
    },
    {
        title:'Business',
        value:'09'
    },
    {
        title:'Blog',
        value:'18'
    },
    {
        title:'Corporate',
        value:'20'
    },
    {
        title:'Investment',
        value:'22'
    }, 
]

export const recentPost = [
    {
        image:blog7,
        title:'Consultant Business',
        date:'13th March, 2024'
    },
    {
        image:blog8,
        title:'Look On The Glorious Balance',
        date:'5th May, 2024'
    },
    {
        image:blog1,
        title:'Research Financial.',
        date:'19th June, 2024'
    },
]

export const cloud = [
    'Business','Finance','Marketing','Fashion','Bride','Lifestyle','Travel','Beauty','Video','Audio',
]
export const social = [
   "mdi mdi-facebook", "mdi mdi-instagram","mdi mdi-twitter","mdi mdi-vimeo","mdi mdi-linkedin","mdi mdi-google-plus"
]
export const blogGallery = [
    portfolio1,portfolio2,portfolio3,portfolio4,portfolio5,portfolio6,portfolio7,portfolio8,portfolio9,portfolio10,portfolio11,portfolio12,
]

export const sliderImg = [
    blog17,blog16,blog15
]